import {
    PaddockIcon,
    FenceIcon,
    WaterwayIcon,
    DamIcon,
    GateIcon,
    SiloIcon,
    TankIcon,
    VegetationIcon,
    HouseIcon,
    ShedIcon,
    YardIcon,
    CoolRoomIcon,
    BridgeCrossingIcon,
    ErosionAreaIcon,
    NoteIcon,
    TaskIcon,
    HerdIcon,
    TroughIcon,
} from 'app/agriculture/icons';
import { AssetType } from 'app/shared/collections/asset_type';
import { isKeyOfObject } from 'app/agriculture/type-utils/isKeyOfObject/isKeyOfObject';
import { IconBaseProps } from 'react-icons';
import { BoundaryIcon } from 'app/agriculture/icons/assets/BoundaryIcon';

const assetIconLookup = {
    Paddock: PaddockIcon,
    Fence: FenceIcon,
    Waterway: WaterwayIcon,
    Gate: GateIcon,
    Dam: DamIcon,
    Silo: SiloIcon,
    Tank: TankIcon,
    Vegetation: VegetationIcon,
    House: HouseIcon,
    Trough: TroughIcon,
    Shed: ShedIcon,
    Yard: YardIcon,
    'Cool Room': CoolRoomIcon,
    'Bridge Crossing': BridgeCrossingIcon,
    'Erosion Area': ErosionAreaIcon,
    Note: NoteIcon,
    Task: TaskIcon,
    Herd: HerdIcon,
    Boundary: BoundaryIcon,
};

interface AssetIconProps extends IconBaseProps {
    name: AssetType['name'];
}

export function AssetIcon({ name, ...iconProps }: AssetIconProps) {
    if (!isKeyOfObject(name, assetIconLookup)) {
        console.error(`AssetIcon: unable to find icon for asset type: ${name}`);
        return <></>;
    }

    const Icon = assetIconLookup[name];
    return <Icon {...iconProps} />;
}
